import { createColumnHelper } from '@tanstack/react-table';

import { ColumnTypesInternal, WebEDIRowData } from 'support/types/webediTable';
import { HeaderCell } from 'components/DataTable/cells/HeaderCell';
import { Translate } from 'components/Translate/Translate';

import { ProductLogCell } from './ProductLogCells';

/**
 * A custom, read-only display column — not a spec `ui.Field` — so it is built and injected
 * separately from `useGenerateWebEDIColumns`'s output, following the same pattern as
 * `components/DataTable/columns/indexColumn.tsx`. Typed against `WebEDIRowData`, like every other
 * `DataTable` column, so it combines into one column array with the generated ones; `row.original`
 * is cast to `ProductRow` at the point of use, same as other WebEDI cells narrow specific fields
 * off the deliberately loose `WebEDIRowData`.
 */
export const productLogColumn = (columnHelper: ReturnType<typeof createColumnHelper<WebEDIRowData>>) =>
  columnHelper.display({
    id: ColumnTypesInternal.procuros_log,
    header: (props) => (
      <HeaderCell {...props} mode={props.table.options.meta?.mode}>
        <Translate i18nKey="settings:productMasterdata.table.headers.log" />
      </HeaderCell>
    ),
    meta: { type: ColumnTypesInternal.procuros_log },
    cell: ProductLogCell,
  });
